#### Relaxed string length limits

We have relaxed our length validation on `String` input fields.
Previously, string lengths were measured and specified in terms of bytes in UTF-8 encoding.
This was stricter than common validation approaches on the web,
including the HTML [`maxlength` attribute] and JavaScript [`String.length` property].

Now, the SEEK API measures and specifies string lengths in terms of Unicode code points or colloquially _characters_.
This is a closer match to the graphemes visible to an end user,
and should provide more equitable support for other scripts and special characters.

See [string lengths] for more information.

[`maxlength` attribute]: https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Attributes/maxlength
[`string.length` property]: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/length
[string lengths]: /graphql/seek-api-conventions#string-lengths
